import { createSelector } from 'reselect';
var getLoginInfo = function (state) { return state.auth; };
export var getUserInfoSelector = createSelector(getLoginInfo, function (loginInfo) { return loginInfo.userInfo; });
export var userInfoSelectUserInfo = function (state) { return state.auth.userInfo; };
export var isSigningOut = function (state) { return state.auth.isSigningOut; };
export var errorSelector = function (state) { return state.auth.error; };
